module.exports = __webpack_public_path__ + "media/images/front/about/point1_img02-c8cb9501df1fcbb38bdb60eaecb56843.jpg";